import React, { useState } from 'react';
import Modal from 'react-modal';

import CloseIcon from '../../assets/svg/close.inline.svg';
import { MarketoForm } from '../marketo-form';
import * as styles from './marketo-popup.module.css';
import { MarketoPopupSkeleton } from './marketo-popup-skeleton';

interface PortableTextBlock {
	_type: string;
	style: string;
	children: {
		_type: string;
		text: string;
		marks: string[];
	}[];
	markDefs: {
		_type: string;
		_key: string;
		href: string;
	}[];
}

interface MarketoFormData {
	id: string;
	_rawDisclaimer?: PortableTextBlock[];
	analyticsOnStart?: {
		enableGA4?: boolean;
		ga4Event?: {
			name: string;
		};
	};
	analyticsOnSubmit?: {
		enableGA4?: boolean;
		ga4Event?: {
			name: string;
		};
	};
	eyebrowText?: string;
	formId: string;
	headerText?: string;
	subheaderText?: string;
	thankYouMessage?: PortableTextBlock[];
}

interface MarketoPopupProps {
	enableChiliPiper: boolean;
	enableGrowSurf: boolean;
	enableRecaptcha: boolean;
	ldConversionTracking: boolean;
	ldEventKey: string;
	marketoForm: MarketoFormData;
	marketoPopupOpen: boolean;
	setMarketoPopupOpen: (value: boolean) => void;
}

export function MarketoPopup({
	enableChiliPiper,
	enableGrowSurf,
	enableRecaptcha,
	ldConversionTracking,
	ldEventKey,
	marketoForm,
	marketoPopupOpen,
	setMarketoPopupOpen,
}: MarketoPopupProps) {
	// state
	const [formReady, setFormReady] = useState(false);

	const onRender = () => {
		setFormReady(true);
	};

	const onSuccess = () => {
		setTimeout(() => {
			setMarketoPopupOpen(false);
		}, 3000);
	};

	const modalStyles = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -44%)',
			backgroundColor: '#f1f3ef',
			padding: 'var(--stack-card-padding-md)',
			maxWidth: '90vw',
			maxHeight: '84vh',
			zIndex: '1000',
		},
		overlay: {
			zIndex: 1,
			backgroundColor: 'rgba(0, 0, 0, 0.20)',
		},
	};

	return (
		<Modal
			ariaHideApp={false}
			contentLabel='Get Started'
			isOpen={marketoPopupOpen}
			onRequestClose={() => setMarketoPopupOpen(false)}
			style={modalStyles}
		>
			<button
				className={styles.closeButton}
				onClick={() => setMarketoPopupOpen(false)}
			>
				<CloseIcon />
			</button>
			<div className={formReady ? undefined : styles.hidden}>
				<MarketoForm
					backgroundColor='white'
					className='twocol'
					columnLayout='twocol'
					enableChiliPiper={enableChiliPiper}
					enableRecaptcha={enableRecaptcha}
					eyebrowTextOverride=''
					formCtaCopy='Submit'
					formWidth='formWide'
					growsurf={enableGrowSurf}
					headerTextOverride=''
					isPopupForm
					ldConversionTracking={ldConversionTracking}
					ldEventKey={ldEventKey}
					marketoForm={marketoForm}
					onRender={onRender}
					onSuccess={onSuccess}
					resourceLayout={false}
					setResourceFormCookie={false}
					subheaderTextOverride=''
					thankYouMessageOverride=''
				/>
			</div>
			{!formReady && <MarketoPopupSkeleton />}
		</Modal>
	);
}
